import React from 'react';
import { NavLink } from 'react-router-dom';
import Switcher from '../Elements/Switcher';

class Footer extends React.Component {
    render() {

        return (
            <>
                <footer className="site-footer footer-large  footer-dark	footer-wide">
                    {/* FOOTER BLOCKES START */}
                    <div className="footer-top overlay-wraper">
                        <div className="overlay-main" />
                        <div className="container">
                            <div className="row">
                                {/* ABOUT COMPANY */}
                                <div className="col-lg-3 col-md-6 col-sm-6">
                                    <div className="widget widget_about">
                                        {/*<h4 class="widget-title">About Company</h4>*/}
                                        <div className="logo-footer clearfix p-b15">
                                            <NavLink to={"./"}>
                                                <img style={{backgroundColor:'white', border:1, borderRadius:'10%' }} src={require('./../../images/logo-1.png')} alt="Inteshape" />
                                            </NavLink>
                                        </div>
                                        <p>bureau d'études spécialisé en structures, offre son expertise à toutes les phases du cycle d'un projet de génie civil</p>
                                        <ul className="social-icons  sx-social-links">
                                            <li><a href="https://tn.linkedin.com/in/adem-jlel-950808176" className="fa fa-linkedin" target="_blank"></a></li>
                                            <li><a href="https://www.facebook.com/people/Adem-JLEL-Ing%C3%A9nieur-conseil/61561553002960/?mibextid=ZbWKwL" className="fa fa-facebook" target="_blank"></a></li>
                                            
                                        </ul>
                                    </div>
                                </div>
                                {/* RESENT POST */}
                                
                                {/* USEFUL LINKS */}
                                <div className="col-lg-3 col-md-6 col-sm-6 footer-col-3">
                                    <div className="widget widget_services inline-links">
                                        <h5 className="widget-title"> Liens </h5>
                                        <ul>
                                            <li><NavLink to={"/about-1"}>A propos de nous  </NavLink></li>
                                           
                                            <li><NavLink to={"/contact-us"}>Contact </NavLink></li>
                                        </ul>
                                    </div>
                                </div>
                                {/* CONTACT US */}
                                <div className="col-lg-3 col-md-6 col-sm-6">
                                    <div className="widget widget_address_outer">
                                        <h5 className="widget-title">Contact </h5>
                                        <ul className="widget_address">
                                            <li>jleladem@gmail.com</li>
                                            <li> 03 rue 20 mars kairouan , Tunisie</li>
                                            <li>(+216) 95 411 127 </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="container">
                            <div className="call-to-action-wrap">
                                <div className="row">
                                    <div className="col-lg-7 col-md-6">
                                        <div className="call-to-action-left">
                                            <h5 className="text-uppercase m-b10 m-t0">Regoindre notre reseau !</h5>
                                            <span> Laissez votre adresse mail .</span>
                                        </div>
                                    </div>
                                    <div className="col-lg-5 col-md-6">
                                        <div className="call-to-action-right">
                                            <div className="widget_newsletter">
                                                <div className="newsletter-bx">
                                                    <form role="search" method="post" action="#">
                                                        <div className="input-group">
                                                            <input name="news-letter" className="form-control" placeholder="ENTEZ VOTRE EMAIL" type="text" />
                                                            <span className="input-group-btn">
                                                                <button type="button" className="site-button"><i className="fa fa-paper-plane-o" /></button>
                                                            </span>
                                                        </div>
                                                    </form>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* FOOTER COPYRIGHT */}
                    <div className="footer-bottom overlay-wraper">
                        <div className="overlay-main" />
                        <div className="container">
                            <div className="row">
                                <div className="sx-footer-bot-left">
                                    <span className="copyrights-text">© 2024 ACE.</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </footer>
                <Switcher/>

            </>
        );
    };
};

export default Footer;